import React from 'react';
import { Props } from '../SvgProps';
import NoRecordsBase from './NoRecordsBase';

const NoRecordsSmall: React.FC<Props & {
  bgColor?: string;
  shadowColor?: string;
  circleColor?: string;
  borderColor?: string;
}> = ({ color, bgColor, shadowColor, circleColor, borderColor }) => (
  <NoRecordsBase
    width="120"
    height="120"
    color={color}
    bgColor={bgColor}
    shadowColor={shadowColor}
    circleColor={circleColor}
    borderColor={borderColor}
  />
);

export default NoRecordsSmall;